import { render, staticRenderFns } from "./BrandContent.vue?vue&type=template&id=a1b9ef52&scoped=true"
import script from "./BrandContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BrandContent.vue?vue&type=style&index=0&id=a1b9ef52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b9ef52",
  null
  
)

export default component.exports